import { RATED_ENGLISH_AUTHORITIES, } from './authority-data.js';
import { councilEntities, } from './council-entities.js';
import { COUNCIL_REPORT_PAGE_BY_SLUG } from './council-report-pages.js';
export const OPEN_GOVERNMENT_LICENCE_V3 = 'https://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/';
export const COUNCIL_DATASET_LANDING_PATH = '/data/council-road-maintenance-ratings';
export const COUNCIL_DATASET_JSON_PATH = '/data/council-road-maintenance-ratings-2025-2026-v1.json';
export const COUNCIL_DATASET_CSV_PATH = '/data/council-road-maintenance-ratings-2025-2026-v1.csv';
export const COUNCIL_DATASET_CORRECTION_URL = `https://fixtyer.co.uk${COUNCIL_DATASET_LANDING_PATH}#corrections`;
export const DFT_RATINGS_SOURCE = Object.freeze({
    id: 'dft-local-road-maintenance-ratings-2025-2026',
    type: 'rating-publication',
    title: 'Local road maintenance ratings 2025 to 2026',
    publisher: 'Department for Transport',
    url: 'https://www.gov.uk/government/publications/local-road-maintenance-ratings/local-road-maintenance-ratings-2025-to-2026',
    licenseUrl: OPEN_GOVERNMENT_LICENCE_V3,
});
const TRANSPARENCY_REPORT_URLS = Object.freeze({
    bedford: 'https://www.bedford.gov.uk/parking-roads-and-travel/local-highways-maintenance-transparency-report',
    bolton: 'https://www.bolton.gov.uk/downloads/file/7120/local-highways-maintenance-transparency-report',
    cumberland: 'https://www.cumberland.gov.uk/parking-roads-and-transport/highways-strategies',
    derbyshire: 'https://www.derbyshire.gov.uk/transport-roads/highway-policy-funding/local-highways-maintenance-transparency-report/local-highways-maintenance-transparency-report.aspx',
    dudley: 'https://www.dudley.gov.uk/residents/parking-and-roads/street-care-and-maintenance/local-highways-maintenance-transparency-report/',
    greenwich: 'https://www.royalgreenwich.gov.uk/parking-transport-and-streets/policies-and-reports-about-parking-transport-and-streets/local',
    leicestershire: 'https://www.leicestershire.gov.uk/roads-and-travel/road-maintenance/local-highways-maintenance-and-improvements',
    'north-lincolnshire': 'https://www.northlincs.gov.uk/site/documents/transport-and-streets/highways-maintenance-transparency-report/',
    slough: 'https://www.slough.gov.uk/parking-roads-travel/highways-maintenance-funding',
    suffolk: 'https://www.suffolk.gov.uk/asset-library/SCC-Local-highways-maintenance-transparency-report-June-25-Final-V0.0.pdf',
    'west-northamptonshire': 'https://www.westnorthants.gov.uk/highway-maintenance/local-highways-maintenance-transparency-report',
    'westmorland-and-furness': 'https://www.westmorlandandfurness.gov.uk/sites/default/files/2025-06/Local%20Highways%20Maintenance%20Transparency%20Report%202025%20to%202026.pdf',
});
const TRANSPARENCY_REPORT_PERIODS = Object.freeze({
    bedford: 'June 2025',
    bolton: '2025',
    cumberland: 'June 2025',
    derbyshire: '2025',
    dudley: 'July 2025',
    greenwich: 'June 2025',
    leicestershire: '2025',
    'north-lincolnshire': 'January 2026',
    slough: 'June 2025',
    suffolk: 'June 2025',
    'west-northamptonshire': 'April 2026',
    'westmorland-and-furness': 'June 2025',
});
const OBSERVED_FACT_SEEDS = Object.freeze({
    bedford: [
        {
            id: 'pothole-fills-2024-25',
            observation: 'The June 2025 transparency report records 6,308 estimated potholes filled in 2024/25.',
            asOfPeriod: 'June 2025',
        },
    ],
    bolton: [
        {
            id: 'u-road-condition-2024-25',
            observation: 'The 2025 transparency report records 34% of unclassified roads in its red condition category for 2024/25 and says those roads are surveyed annually using visual inspection.',
            asOfPeriod: '2025',
        },
    ],
    cumberland: [
        {
            id: 'u-road-condition-2024',
            observation: 'The June 2025 transparency report records 25% of U-roads as red and 27% as amber in the 2024 survey.',
            asOfPeriod: 'June 2025',
        },
    ],
    derbyshire: [
        {
            id: 'u-road-poor-condition-2024',
            observation: 'The 2025 transparency report records 36% of U-roads in poor condition in 2024, compared with 21% in 2020.',
            asOfPeriod: '2025',
        },
    ],
    dudley: [
        {
            id: 'u-road-survey-cycle-2025',
            observation: 'The July 2025 transparency report records 853.4km of U-roads, with 25% surveyed each year on a four-year cycle.',
            asOfPeriod: 'July 2025',
        },
        {
            id: 'maintenance-spend-split-2025-26',
            observation: 'The July 2025 transparency report records 6% preventative and 22% reactive maintenance spend for 2025/26.',
            asOfPeriod: 'July 2025',
        },
    ],
    greenwich: [
        {
            id: 'classified-road-data-gap-2025',
            observation: 'The June 2025 transparency report records 59% of C-roads and 30% of B-roads in its red category when last surveyed in 2021/22, with updated results still awaited.',
            asOfPeriod: 'June 2025',
        },
    ],
    leicestershire: [
        {
            id: 'reactive-approach-statement-2025',
            observation: 'The 2025 transparency report states that reduced planned maintenance led to more urgent repairs and describes that reactive approach as unsustainable.',
            asOfPeriod: '2025',
        },
    ],
    'north-lincolnshire': [
        {
            id: 'survey-method-change-2026',
            observation: 'The transparency report updated in January 2026 says the 2024 classified-road figures used an Annual Engineers Inspection instead of the council’s traditional SCANNER survey method.',
            asOfPeriod: 'January 2026',
        },
    ],
    slough: [
        {
            id: 'pothole-fills-2024-25',
            observation: 'The June 2025 transparency report records estimated pothole fills rising from 377 in 2020/21 to 1,393 in 2024/25, a 269% increase.',
            asOfPeriod: 'June 2025',
        },
        {
            id: 'section-114-maintenance-restriction',
            observation: 'The June 2025 transparency report records that revenue and capital spend was restricted to emergencies only after the July 2021 Section 114 notice and that no condition surveys were collected in 2022.',
            asOfPeriod: 'June 2025',
        },
    ],
    suffolk: [
        {
            id: 'a-road-condition-2024',
            observation: 'The June 2025 transparency report records A-road green condition at 67.5% and amber condition at 30.0% in 2024.',
            asOfPeriod: 'June 2025',
        },
        {
            id: 'u-road-survey-gap-2024-25',
            observation: 'The June 2025 transparency report says U-road condition data is unavailable for 2024/25 because the council changed survey methodology.',
            asOfPeriod: 'June 2025',
        },
    ],
    'west-northamptonshire': [
        {
            id: 'bc-road-condition-2024',
            observation: 'The April 2026 transparency report records 7.57% of B/C roads in its green condition category in 2024.',
            asOfPeriod: 'April 2026',
        },
        {
            id: 'preventative-spend-2024-25',
            observation: 'The April 2026 transparency report records 4% of maintenance spend as preventative in 2024/25.',
            asOfPeriod: 'April 2026',
        },
    ],
    'westmorland-and-furness': [
        {
            id: 'pothole-fills-2024-25',
            observation: 'The June 2025 transparency report records 34,228 pothole fills in 2024/25 and notes a change to per-repair counting from mid-2023/24.',
            asOfPeriod: 'June 2025',
        },
    ],
});
function stableAuthorityId(name) {
    return name
        .normalize('NFKD')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '');
}
function reportSlug(name) {
    if (name === 'Kingston upon Hull, City of')
        return 'hull';
    if (name === 'City of York')
        return 'york';
    return stableAuthorityId(name);
}
function displayName(name) {
    if (name === 'Kingston upon Hull, City of')
        return 'Hull';
    if (name === 'City of York')
        return 'York';
    return name;
}
function ratingLabel(rating) {
    return rating ?? 'not scored';
}
function claimSafeSummary(name, ratings) {
    return (`The Department for Transport recorded ${name} as ${ratings.overall.toUpperCase()} overall ` +
        `for 2025-2026, with condition ${ratingLabel(ratings.condition).toUpperCase()}, ` +
        `spend ${ratingLabel(ratings.spend).toUpperCase()} and best practice ` +
        `${ratingLabel(ratings.bestPractice).toUpperCase()}. These are network-level rating bands; ` +
        'the rating does not determine liability for a particular incident.');
}
function provenance(sourceId, observed, calculation) {
    return { sourceId, observed, calculation };
}
function transparencySource(slug, publisher) {
    const url = TRANSPARENCY_REPORT_URLS[slug];
    return url
        ? {
            id: `${slug}-local-highways-maintenance-transparency`,
            type: 'transparency-report',
            title: 'Local highways maintenance transparency information',
            publisher,
            url,
            reportPeriod: TRANSPARENCY_REPORT_PERIODS[slug],
        }
        : null;
}
function observedFacts(slug) {
    const sourceUrl = TRANSPARENCY_REPORT_URLS[slug];
    const seeds = OBSERVED_FACT_SEEDS[slug] ?? [];
    if (!sourceUrl) {
        if (seeds.length > 0) {
            throw new Error(`${slug} has bespoke facts without a transparency source`);
        }
        return [];
    }
    return seeds.map((seed) => ({
        ...seed,
        sourceId: `${slug}-local-highways-maintenance-transparency`,
        sourceUrl,
        cautiousInterpretation: 'This is authority-level context and does not determine liability for a particular incident.',
    }));
}
function buildManifest() {
    return RATED_ENGLISH_AUTHORITIES.map((authority) => {
        if (!authority.dftOverallRating) {
            throw new Error(`${authority.name} has no overall DfT rating`);
        }
        const authorityId = stableAuthorityId(authority.name);
        const slug = reportSlug(authority.name);
        const entity = councilEntities[slug] ?? null;
        const reportPage = COUNCIL_REPORT_PAGE_BY_SLUG.get(slug) ?? null;
        const ratings = {
            overall: authority.dftOverallRating,
            condition: authority.dftConditionRating,
            spend: authority.dftSpendRating,
            bestPractice: authority.dftBestPracticeRating,
        };
        const councilSource = transparencySource(slug, entity?.name ?? displayName(authority.name));
        return {
            authorityId,
            slug,
            canonicalName: authority.name,
            displayName: displayName(authority.name),
            nation: 'England',
            region: authority.region,
            ratings,
            ratingPeriod: '2025-2026',
            reportUrl: reportPage?.reportUrl ?? null,
            sources: councilSource
                ? [DFT_RATINGS_SOURCE, councilSource]
                : [DFT_RATINGS_SOURCE],
            provenance: {
                identity: provenance(DFT_RATINGS_SOURCE.id, 'Authority name and England coverage are transcribed from the DfT rated-authority table.', 'The stable authority ID is a lowercase ASCII normalisation of the DfT authority name; the page slug uses the existing Fixtyer route where one exists.'),
                ratings: provenance(DFT_RATINGS_SOURCE.id, 'Overall, condition, spend and best-practice bands are transcribed from the DfT 2025-2026 publication.', 'No rating is inferred. A null component means the checked-in DfT table did not provide that component rating.'),
                reportUrl: provenance('fixtyer-public-routes', reportPage
                    ? `The existing public council report route is ${reportPage.reportUrl}.`
                    : 'No Fixtyer council report route exists for this rated authority.', 'No route is invented when page coverage is absent.'),
                entities: provenance('fixtyer-verified-entities-2026-06-12', entity
                    ? 'Official-site, Wikidata and Wikipedia links were previously verified and are preserved.'
                    : 'No verified entity mapping is held.', 'Missing mappings remain null; entity URLs and identifiers are never guessed.'),
                interpretation: provenance(DFT_RATINGS_SOURCE.id, 'The observed fact is the published network-level rating band.', 'Fixtyer adds only a cautious explanation: the rating is context and does not determine liability for a particular incident.'),
            },
            claimSafeSummary: claimSafeSummary(authority.name, ratings),
            observedFacts: observedFacts(slug),
            publishedDate: '2026-07-19',
            reviewedDate: '2026-07-19',
            correction: {
                status: 'no-correction-recorded',
                url: COUNCIL_DATASET_CORRECTION_URL,
            },
            entity,
        };
    }).sort((a, b) => a.canonicalName.localeCompare(b.canonicalName, 'en'));
}
const RATINGS = new Set(['green', 'amber', 'red', null]);
const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;
const UNSUPPORTED_LEGAL_CONCLUSION = /\b(?:proves?|establishes?|demonstrates?)\b[^.]{0,80}\b(?:liable|liability|negligent|negligence|breach)\b|\bundermines?\b[^.]{0,80}\bsection 58\b|\bentitled to compensation\b/i;
function isValidDate(value) {
    if (!ISO_DATE.test(value))
        return false;
    const timestamp = Date.parse(`${value}T00:00:00Z`);
    return !Number.isNaN(timestamp) &&
        new Date(timestamp).toISOString().slice(0, 10) === value;
}
function assertUrl(value, label, allowRelative = false) {
    try {
        const parsed = new URL(value, allowRelative ? 'https://fixtyer.co.uk' : undefined);
        if (!['http:', 'https:'].includes(parsed.protocol))
            throw new Error('invalid protocol');
    }
    catch {
        throw new Error(`Invalid ${label}: ${value}`);
    }
}
export function validateCouncilReportManifest(manifest) {
    if (manifest.length !== 154) {
        throw new Error(`Expected 154 authorities, received ${manifest.length} authorities`);
    }
    const ids = new Set();
    const slugs = new Set();
    const overallCounts = { green: 0, amber: 0, red: 0 };
    for (const entry of manifest) {
        if (ids.has(entry.authorityId))
            throw new Error(`Duplicate authority ID: ${entry.authorityId}`);
        if (slugs.has(entry.slug))
            throw new Error(`Duplicate authority slug: ${entry.slug}`);
        ids.add(entry.authorityId);
        slugs.add(entry.slug);
        if (!/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(entry.authorityId)) {
            throw new Error(`Invalid authority ID: ${entry.authorityId}`);
        }
        if (!/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(entry.slug)) {
            throw new Error(`Invalid authority slug: ${entry.slug}`);
        }
        for (const [field, rating] of Object.entries(entry.ratings)) {
            if (!RATINGS.has(rating))
                throw new Error(`Invalid ${field} rating for ${entry.slug}`);
        }
        overallCounts[entry.ratings.overall] += 1;
        if (entry.ratingPeriod !== '2025-2026') {
            throw new Error(`Invalid rating period for ${entry.slug}`);
        }
        if (!isValidDate(entry.publishedDate) || !isValidDate(entry.reviewedDate)) {
            throw new Error(`Invalid date for ${entry.slug} publication or review`);
        }
        if (entry.reportUrl)
            assertUrl(entry.reportUrl, `${entry.slug} report URL`, true);
        assertUrl(entry.correction.url, `${entry.slug} correction URL`);
        for (const source of entry.sources) {
            assertUrl(source.url, `${entry.slug} source URL`);
            if (source.licenseUrl)
                assertUrl(source.licenseUrl, `${entry.slug} source licence URL`);
            if (source.publishedDate && !isValidDate(source.publishedDate)) {
                throw new Error(`Invalid source publication date for ${entry.slug}`);
            }
        }
        const sourceById = new Map(entry.sources.map((source) => [source.id, source]));
        const factIds = new Set();
        for (const fact of entry.observedFacts) {
            if (factIds.has(fact.id)) {
                throw new Error(`Duplicate observed fact ID for ${entry.slug}: ${fact.id}`);
            }
            factIds.add(fact.id);
            const source = sourceById.get(fact.sourceId);
            if (!source || source.url !== fact.sourceUrl) {
                throw new Error(`Invalid observed fact provenance for ${entry.slug}: ${fact.id}`);
            }
            if (!/^(?:[A-Z][a-z]+ )?20\d{2}$/.test(fact.asOfPeriod)) {
                throw new Error(`Invalid observed fact period for ${entry.slug}: ${fact.id}`);
            }
            if (UNSUPPORTED_LEGAL_CONCLUSION.test(fact.observation) ||
                UNSUPPORTED_LEGAL_CONCLUSION.test(fact.cautiousInterpretation) ||
                /\bundermines?\b[^.]{0,100}\bsection 58\b|\bentitled to compensation\b/i.test(`${fact.observation} ${fact.cautiousInterpretation}`)) {
                throw new Error(`Unsupported legal conclusion in ${entry.slug} observed fact`);
            }
        }
        if (entry.entity) {
            assertUrl(entry.entity.website, `${entry.slug} official-site URL`);
            assertUrl(entry.entity.wikidata, `${entry.slug} Wikidata URL`);
            assertUrl(entry.entity.wikipedia, `${entry.slug} Wikipedia URL`);
        }
        if (UNSUPPORTED_LEGAL_CONCLUSION.test(entry.claimSafeSummary)) {
            throw new Error(`Unsupported legal conclusion in ${entry.slug} summary`);
        }
    }
    if (overallCounts.green !== 16 ||
        overallCounts.amber !== 125 ||
        overallCounts.red !== 13) {
        throw new Error(`DfT overall count mismatch: ${overallCounts.green} green + ` +
            `${overallCounts.amber} amber + ${overallCounts.red} red`);
    }
    const missingReportPages = manifest
        .filter(({ reportUrl }) => !reportUrl)
        .map(({ slug }) => slug);
    const missingVerifiedEntities = manifest
        .filter(({ entity }) => !entity)
        .map(({ slug }) => slug);
    if (missingReportPages.length !== 1 ||
        missingReportPages[0] !== 'transport-for-london') {
        throw new Error(`Unexpected report page coverage: ${missingReportPages.join(', ')}`);
    }
    if (missingVerifiedEntities.length !== 1 ||
        missingVerifiedEntities[0] !== 'transport-for-london') {
        throw new Error(`Unexpected verified entity coverage: ${missingVerifiedEntities.join(', ')}`);
    }
    return {
        authorities: manifest.length,
        reportPages: manifest.length - missingReportPages.length,
        verifiedEntities: manifest.length - missingVerifiedEntities.length,
        missingReportPages,
        missingVerifiedEntities,
    };
}
export const COUNCIL_REPORT_MANIFEST = Object.freeze(buildManifest());
export const COUNCIL_REPORT_MANIFEST_BY_SLUG = new Map(COUNCIL_REPORT_MANIFEST.map((entry) => [entry.slug, entry]));
export const COUNCIL_REPORT_MANIFEST_BY_AUTHORITY_ID = new Map(COUNCIL_REPORT_MANIFEST.map((entry) => [entry.authorityId, entry]));
export const COUNCIL_REPORT_MANIFEST_VALIDATION = validateCouncilReportManifest(COUNCIL_REPORT_MANIFEST);
export const COUNCIL_DATASET_METADATA = Object.freeze({
    title: 'England council road maintenance ratings 2025-2026 v1',
    version: '2025-2026-v1',
    publisher: 'Fixtyer',
    creator: 'Fixtyer',
    sourcePublisher: 'Department for Transport',
    sourceUrl: DFT_RATINGS_SOURCE.url,
    license: OPEN_GOVERNMENT_LICENCE_V3,
    spatialCoverage: 'England',
    temporalCoverage: '2025-2026',
    publishedDate: '2026-07-19',
    modifiedDate: '2026-07-19',
    authorityCount: 154,
    coverage: 'All 154 authorities in the checked-in DfT England ratings. Wales uses a separate system and is not rated in this dataset.',
    correctionUrl: COUNCIL_DATASET_CORRECTION_URL,
});
export function generateCouncilDatasetJson() {
    return `${JSON.stringify({
        metadata: COUNCIL_DATASET_METADATA,
        authorities: COUNCIL_REPORT_MANIFEST,
    }, null, 2)}\n`;
}
export function escapeCouncilDatasetCsvValue(value) {
    const text = value === null || value === undefined ? '' : String(value);
    const spreadsheetSafeText = /^\s*[=+\-@]/.test(text) ? `'${text}` : text;
    return /[",\r\n]/.test(spreadsheetSafeText)
        ? `"${spreadsheetSafeText.replace(/"/g, '""')}"`
        : spreadsheetSafeText;
}
export function generateCouncilDatasetCsv() {
    const headers = [
        'authority_id',
        'slug',
        'canonical_name',
        'display_name',
        'nation',
        'region',
        'overall_rating',
        'condition_rating',
        'spend_rating',
        'best_practice_rating',
        'rating_period',
        'fixtyer_report_url',
        'dft_source_url',
        'source_publisher',
        'license_name',
        'license_url',
        'official_site',
        'wikidata',
        'wikipedia',
        'published_date',
        'reviewed_date',
        'correction_status',
        'claim_safe_summary',
        'observed_facts_json',
        'identity_provenance',
        'rating_provenance',
        'report_url_provenance',
        'entity_provenance',
        'interpretation_provenance',
    ];
    const provenanceText = (field) => `${field.observed} Calculation/normalisation: ${field.calculation}`;
    const rows = COUNCIL_REPORT_MANIFEST.map((entry) => [
        entry.authorityId,
        entry.slug,
        entry.canonicalName,
        entry.displayName,
        entry.nation,
        entry.region,
        entry.ratings.overall,
        entry.ratings.condition,
        entry.ratings.spend,
        entry.ratings.bestPractice,
        entry.ratingPeriod,
        entry.reportUrl,
        DFT_RATINGS_SOURCE.url,
        DFT_RATINGS_SOURCE.publisher,
        'Open Government Licence v3.0',
        OPEN_GOVERNMENT_LICENCE_V3,
        entry.entity?.website,
        entry.entity?.wikidata,
        entry.entity?.wikipedia,
        entry.publishedDate,
        entry.reviewedDate,
        entry.correction.status,
        entry.claimSafeSummary,
        JSON.stringify(entry.observedFacts),
        provenanceText(entry.provenance.identity),
        provenanceText(entry.provenance.ratings),
        provenanceText(entry.provenance.reportUrl),
        provenanceText(entry.provenance.entities),
        provenanceText(entry.provenance.interpretation),
    ]);
    return `${[headers, ...rows]
        .map((row) => row.map(escapeCouncilDatasetCsvValue).join(','))
        .join('\r\n')}\r\n`;
}
